import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  "aria-label": "artikel"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M9,16 L4,21 L4,16 L4,6 L20,6 L20,16 L9,16 Z"
})));